<template>
  <div>
    <!--销售报表-->
    <header class="form-title">
      <Row>
        <Col span="24">
          <Form inline :label-width="80">
            <FormItem label="选择时间">
              <DatePicker
                split-panels
                type="daterange"
                :options="options"
                placeholder="选择日期"
                @on-change="changeTime"
                :value="valuedate"
              >
              </DatePicker>
            </FormItem>
            <FormItem label="店铺" v-if="isCustomerSharing == 1">
              <Select v-model="shopName" filterable style="width: 200px">
                <Option
                  v-if="k.isCustomerSharing == 1 || k.isgeneralwarehouse == 'Y'"
                  :value="k.id"
                  v-for="(k, v) in shopList"
                  :key="v"
                  >{{ k.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="商品名称\货号" label-width="100">
              <Input
                type="text"
                v-model="condition"
                placeholder="请输入商品名称\货号"
              />
            </FormItem>
            <FormItem label="客户名称\电话" label-width="100">
              <Input
                type="text"
                v-model="conditionCust"
                placeholder="请输入客户名称\电话"
              />
            </FormItem>
            
            <FormItem label="客户类型">
                <select
                class="cType"
               
                v-model="customerType"
                
              >
                <option value="">全部</option>
                <option value="0">零售客户</option>
                <option value="1">批发客户</option>
              </select>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="searchList">搜索</Button>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="exportExcel">导出excel</Button>
            </FormItem>
          </Form>
          
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <Form inline :label-width="80">
            <FormItem label="商品数:" style="margin-right: 1rem">
              <strong class="result">{{ totlemoney.totalNums }}</strong>
            </FormItem>
            <FormItem label="销售额:" style="margin-right: 1rem">
              <strong class="result">￥{{ totlemoney.totalMoney }}</strong>
            </FormItem>
            <FormItem label="毛利:" v-if="isroule"
              >亲,你还未购买此服务，暂时不
              <strong class="result">￥{{ totlemoney.grossProfit }}</strong>
            </FormItem>
            <FormItem label="毛利率(%):" v-if="isroule">
              <strong class="result">{{ totlemoney.rateOfMargin }}</strong>
            </FormItem>
            <FormItem label="换出量:">
              <strong class="result">{{ totlemoney.buHuoNum }}</strong>
            </FormItem>
            <FormItem label="退货量:">
              <strong class="result">{{ totlemoney.tuiHuoNum }}</strong>
            </FormItem>
          </Form>
        </Col>
      </Row>
    </header>
    <Table stripe :columns="columns" :data="data" :loading="loadingTable">
      <template slot-scope="{ row, index }" slot="firstData">
        <span style="color: #4aca58" v-if="row.type == '退换单'">{{
          row.type
        }}</span>
        <span style="color: #ff5e5e" v-if="row.type == '销售单'">{{
          row.type
        }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button type="primary" size="small" @click="JumpParticular(row)"
          >详情</Button
        >
      </template>
    </Table>
    <div class="pageTotal">
      <Page
        :total="page.pageTotal"
        show-total
        :page-size="page.rows"
        @on-change="onChangePage"
      />
    </div>
  </div>
</template>
<script>
import { exportExcel  } from "@/common/exportExcel";

export default {
  data() {
    return {
      cid: "",
      sid: "",
      options: {
        shortcuts: [
          {
            text: "昨日",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              return [start, start];
            },
          },
          {
            text: "今日",
            value() {
              const end = new Date();
              const start = new Date();
              return [start, end];
            },
          },
          {
            text: "近七日",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
        ],
      },
      columns: [
        { title: "单据", key: "type", align: "center", slot: "firstData" },
        { title: "客户", key: "name", align: "center" },
        { title: "订单号", key: "order", align: "center" },
        { title: "数量", key: "number", align: "center" },
        { title: "单据金额", key: "money", align: "center" },
        { title: "时间", key: "time", align: "center" },
        { title: "操作", key: "edit", align: "center", slot: "action" },
      ],
      data: [],
      totlemoney: {},
      loadingTable: true,
      page: {
        pageTotal: 1,
        page: 1,
        rows: 12,
      },
      pagedatalist: [],
      markList: [], //销售单list
      listGoods: [], //按商品统计时的商品列表
      isroule: true,
      shopName: "",
      shopList: [], //店铺列表
      isCustomerSharing: 0, //客户共享是否开启 0关 1开
      customerType: "", //客户类型
      condition: "", //客户名称
      conditionCust: "" //商品名称
    };
  },
  watch: {
    shopName: {
      deep: true,
      handler: function (newVal, oldVal) {
        this.sid = newVal;
        this.getMarketList(
          this.valuedate[0],
          this.valuedate[1],
          this.page.page,
          this.page.rows
        );
        
      },
    },
  },
  created: function () {
    //获取用户信息
    this.cid = JSON.parse(localStorage.getItem("shop")).cid;
    this.sid = JSON.parse(localStorage.getItem("shop")).id;
    this.isCustomerSharing = JSON.parse(
      localStorage.getItem("shop")
    ).isCustomerSharing;
    this.valuedate[0] = this.nowTime;
    this.valuedate[1] = this.nowTime;
    this.getMarketList(
      this.valuedate[0],
      this.valuedate[1],
      this.page.page,
      this.page.rows
    );
    this.getShopList();
    var PermisCode = JSON.parse(sessionStorage.getItem("access")).code;
    if (!PermisCode.includes("94")) {
      this.isroule = false;
    }
    
  },

  methods: {
//导出excel
exportExcel() {
      const params = {
        cid: this.cid,
        sid: this.sid,
        time: this.valuedate[0],
        endtime: this.valuedate[1],
        customerType: this.customerType,
        conditionCust: this.conditionCust,
      };
      exportExcel(this.$Api.exportExcel, params, this.$Message, new Date().toLocaleString()+"销售报表");
  },

    

    //销售列表
    getMarketList(startTime, endTime, page, rows) {
      this.$Api
        .getMarketListFilter({
          cid: this.cid,
          sid: this.sid,
          page: page,
          rows: rows,
          time: startTime,
          endtime: endTime,
          state: 1,
          condition: this.condition,
          conditionCust: this.conditionCust,
         
          customerType: this.customerType,
        })
        .then((res) => {
          if (res.code == 200) {
            this.data = [];
            this.page.pageTotal = res.count;
            this.pagedatalist = res.data;
            res.data.forEach((item, index) => {
              var PurchaseList = {};
              PurchaseList.id = item.id;
              if (item.state == 1 && item.status == 0) {
                PurchaseList.type = "销售单";
              } else if (item.state == 2 && item.status == 0) {
                PurchaseList.type = "网销单";
              } else if (item.state == 1 && item.status == 2) {
                PurchaseList.type = "退换单";
              }
              (PurchaseList.name = item.customer.name),
                (PurchaseList.order = item.markcode),
                (PurchaseList.number = item.total),
                (PurchaseList.money = item.money),
                (PurchaseList.time = item.time);
              this.data.push(PurchaseList);
            });
            this.loadingTable = false;
            this.getMarketData(startTime, endTime);
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    getMarketData(startTime, endTime) {
      this.$Api
        .getMarketData({
          cid: this.cid,
          sid: this.sid,
          time: startTime,
          endtime: endTime,
          customerType: this.customerType,
          conditionCust: this.conditionCust,
        })
        .then((res) => {
          if (res.code == 200) {
            this.totlemoney = res.data;
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
//根据商品名称或货号搜索商品
searchList() {
      this.getMarketList(
        this.valuedate[0],
        this.valuedate[1],  
        this.page.page,
        this.page.rows,
      );

    },
    //店铺列表
    getShopList() {
      var data = {
        cid: this.cid,
        page: 1,
        rows: 1000,
      };
      this.$Api.getShopList(data).then((res) => {
        this.shopList = res.data;
        this.shopName = JSON.parse(localStorage.getItem("shop")).id;
      });
    },

    //修改时间
    changeTime(time) {
      this.valuedate[0] = time[0];
      this.valuedate[1] = time[1];
      this.getMarketList(
        this.valuedate[0],
        this.valuedate[1],
        this.page.page,
        this.page.rows
      );
    },
    //分页
    onChangePage(num) {
      this.getMarketList(
        this.valuedate[0],
        this.valuedate[1],
        num,
        this.page.rows
      );
    },

    JumpParticular(data) {
      this.pagedatalist.forEach((item, index) => {
        if (item.id == data.id) {
          sessionStorage.setItem("particularDetail", JSON.stringify(item));
        }
      });
      this.$router.push({ path: "/particularDetail" });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-title {
  line-height: 54px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
.result {
  color: #ff5e5e;
}
.tableFirst {
  color: #ff5e5e;
}
.cType {
  width: 100px;

  height: 30px;
  line-height: 30px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-right: 10px;
  color: #666;
  font-size: 14px;
  text-align: center;
  cursor: pointer;

}
.sType {
  width: 125px;

  height: 30px;
  line-height: 30px;
  background-color: #fff;       

  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-right: 10px;
  color: #666;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}

</style> 